<template>
  <v-container>
    <v-layout justify-center>
      <v-flex>
        <template v-if="loading">
          <div class="loading-container">
            <v-progress-circular
              color="primary"
              indeterminate
              class="icon"
            />
          </div>
        </template>
        <template v-else>
          <template v-if="showExpirePointDetails">
            <div class="section-text">
              <h2>{{ $t('pointExpiration.expireScreenHeader1') }}</h2>
              <p class="pre-line">
                {{ $t('pointExpiration.expireScreenText1', { points: expireAmount }) }}
              </p>
            </div>
          </template>
          <v-card class="point-expiration">
            <template v-if="showExpirePointDetails">
              <v-app-bar dark color="primary">
                <h3>{{$t('pointExpiration.headline')}}</h3>
              </v-app-bar>
              <v-list class="pt-0" three-line v-if="expireList.length">
                <span v-for="(item, index) in expireList" :key="item.uuid">
                  <v-list-item>
                    <v-list-item-content class="align-self-center">
                      <v-list-item-title class="text-subtitle-1">
                        {{ $t('pointExpiration.expireScreenDetailsPoints', { points: item.remaining_points }) }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="d-flex align-self-center">
                      <v-list-item-action-text class="text-subtitle-1">
                        {{ $t('pointExpiration.expireScreenDetailsDate', { date: getFomattedDate(item.expiration_date) }) }}
                      </v-list-item-action-text>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < expireList.length"></v-divider>
                </span>
              </v-list>
            </template>
            <template v-else>
              <div class="section-text">
                <h2>{{ $t('pointExpiration.expireScreenHeader2') }}</h2>
                <p class="pre-line">
                  {{ $t('pointExpiration.expireScreenText2', { points: expireAmount }) }}
                </p>
              </div>
            </template>
          </v-card>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import log from 'loglevel'
  import moment from 'moment'
  import {mapState} from 'vuex'
  import {BASE_API_URL} from '@/store'

  export default {
    data() {
      return {
        expireList: [],
        expireAmount: 0,
        loading: true,
      }
    },
    computed: {
      ...mapState(['client_id']),
      showExpirePointDetails() {
        return !this.loading && this.expireList.length && this.expireAmount > 0
      }
    },
    async mounted() {
      await this.fetchExpiringPoints()
    },
    methods: {
      async fetchExpiringPoints() {
        try {
          const response = await this.axios.get(`${BASE_API_URL}/api/v1/customer-relationships/${this.client_id}/points-expiring/`)
          this.expireList = _.get(response.data, 'activities', [])
          this.expireAmount = _.get(response.data, 'sum', 0)
        } catch (error) {
          log.error('Unable to fetch expiring points', error)
        } finally {
          this.loading = false
        }
      },
      getFomattedDate(date) {
        return date ? moment(date).format('DD.MM.YYYY') : ''
      }
    },
  }
</script>

<style lang="scss" scoped>
  .section-text {
    text-align: center;
    padding-bottom: 32px;
    margin: 0 auto;
    max-width: 620px;

    p {
      font-size: 1.125rem;
    }
  }

  .loading-container {
    display: flex;
    justify-content: center;
    margin: 64px auto;
  }

  .point-expiration {
    max-width: 720px;
    margin: 0 auto;
  }
</style>
